import WithGASetup from '../../components/WithGASetup';
import AuthContext from '../../context/AuthContext.js';
import DashboardPage from './DashboardPage.js';

export default WithGASetup(DashboardPage, AuthContext);
